import {
  ColorPickerConfig,
  EMBROIDERY_MAX_COLOR_COUNT,
  EMBROIDERY_MAX_STITCH_COUNT,
  EMBROIDERY_MIN_FONT_SIZE,
} from './embroideryConfig';
import fetchEmbroideryPalette from './fetchEmbroideryPalette';

interface EmbroideryHostSettings {
  digitizeDesignElements: boolean;
  allowSpreadBackgroundColorChange: boolean;
  minFontSize: number;
  digitizationRules: {
    maxColorsCount: number;
    maxStitchCount: number;
  };
  colorPickerConfig: ColorPickerConfig;
  enabledWarnings: {
    LowDPI: boolean;
    NotVisible: boolean;
    OutOfRange: boolean;
    MaxStitchCount: boolean;
    MaxColorCount: boolean;
  };
}

const getEmbroideryHostSettings = async (): Promise<EmbroideryHostSettings> => {
  const colorPickerConfig = await fetchEmbroideryPalette();

  return {
    digitizeDesignElements: true,
    allowSpreadBackgroundColorChange: false,
    minFontSize: EMBROIDERY_MIN_FONT_SIZE,
    digitizationRules: {
      maxColorsCount: EMBROIDERY_MAX_COLOR_COUNT,
      maxStitchCount: EMBROIDERY_MAX_STITCH_COUNT,
    },
    colorPickerConfig,
    enabledWarnings: {
      LowDPI: true,
      NotVisible: true,
      OutOfRange: true,
      MaxStitchCount: true,
      MaxColorCount: true,
    },
  };
};

export default getEmbroideryHostSettings;
